    import React from "react";
    import "../src/assets/css/loader.css";

    const LoaderComponent: React.FC = () => {
        return (
                <div className="builder-loader" >
                    <div><img src="https://d2p078bqz5urf7.cloudfront.net/cloud/prod/assets/img/loader/250x250.gif" alt="Loading..."/></div>
                    <div>Loading...</div>
                </div>
        );
    };

    export default LoaderComponent;